import React, { useEffect, useState } from 'react'
import { getClientUrlDataToken, getDataWithToken } from '../../../Utils/restUtils';
// import HandleApiError from '../../Common/ErrorImport/ErrorImport';
import { NavLink } from 'react-router-dom';
import { overdues } from '../../../CommonURL';

function OverDues() {
    const [overdueItems, setOverdueItems] = useState()

    const fetchOverDues = async () => {
        const data = await getDataWithToken(overdues);
        if (data.status === true) {
            setOverdueItems(data.data);
        } else {
            console.log(data.status);
        }
    }
    useEffect(() => {
        fetchOverDues()
    }, [])
    return (
        <>
            {
                overdueItems?.data.length > 0 ?
                    <div className="card-body p-3" style={{ backgroundColor: '#fef2f2', border: 'solid 1px #F8CCCB ', borderRadius: '20px' }}>
                        {/* Header */}
                        <div className="d-flex justify-content-between align-items-center mb-3">
                            <h5 className="mb-0" style={{ color: '#991b1b', fontWeight: '600' }}>
                                Overdue ({overdueItems?.count})
                            </h5>
                            <NavLink
                                to={'/lead-manage/overdue-follow-ups'}
                                className="text-decoration-none"
                                style={{ color: '#dc2626', fontSize: '0.9rem', fontWeight: '500' }}
                            >
                                View All
                            </NavLink>
                        </div>

                        {/* List Items */}
                        {overdueItems?.data?.map((item, index) => (
                            <div
                                key={item?.name}
                                className={`d-flex justify-content-between align-items-center py-2`}
                                style={{ borderColor: '#fecaca' }}
                            >
                                <span >
                                    <NavLink to={`/lead-manage/leads-details?id=${item.id}`} style={{ color: '#dc2626', fontSize: '0.95rem' }}>
                                        {item.name}
                                    </NavLink>
                                </span>
                                <span style={{ color: '#dc2626', fontSize: '0.9rem' }}>
                                    {item.next_followup}
                                </span>
                            </div>
                        ))}
                    </div>
                    :
                    <div></div>
            }

        </>
    )
}

export default OverDues